import { BunchingStopStat } from '../../../../types/busBunchingTypes';
import { PushpinProps } from '../../../../types/MapModels';

const MIN_BUBBLE_RADIUS = 6;
const MAX_BUBBLE_RADIUS = 20;

export function buildBunchingHeatPushpins(stopStats: BunchingStopStat[] | undefined): PushpinProps[] {
    if (!stopStats || stopStats.length === 0) {
        return [];
    }

    return stopStats
        .filter((stop): stop is BunchingStopStat => Boolean(stop))
        .map((stop) => {
            const count = Math.max(0, Number(stop.count) || 0);
            return {
                location: [stop.lat, stop.lon],
                options: {
                    radius: getBubbleRadius(count),
                    load: count,
                    stopId: stop.id,
                    stopName: stop.name,
                    title: stop.name,
                    catId: 'bunching-heat',
                },
            };
        });
}

function getBubbleRadius(count: number): number {
    return Math.max(MIN_BUBBLE_RADIUS, Math.min(MAX_BUBBLE_RADIUS, Math.round(count)));
}
